/** Lấy `data` từ envelope `{ statusCode, message, data }` hoặc trả về nguyên `raw` nếu không có `data`. */
export function unwrapEnvelopeData<T = unknown>(raw: unknown): T | null {
  if (raw === null || raw === undefined) return null;
  if (typeof raw !== 'object') return raw as T;
  const o = raw as Record<string, unknown>;
  if ('data' in o && o.data !== undefined) return o.data as T;
  return raw as T;
}

/** Payload `data` từ login/refresh thành công. */
export interface LoginEnvelopeData {
  access_token: string;
  user: Record<string, unknown>;
  device_id: string;
}

/**
 * Trích `access_token`, `user`, `device_id` từ body login/refresh (có/không envelope).
 */
export function parseLoginEnvelope(body: unknown): LoginEnvelopeData | null {
  if (!body || typeof body !== 'object') return null;
  const o = body as Record<string, unknown>;
  const inner = unwrapEnvelopeData<Record<string, unknown>>(body);
  const d = (inner && typeof inner === 'object' ? inner : o.data) as
    | Record<string, unknown>
    | undefined;
  if (!d || typeof d !== 'object') return null;
  const access_token = typeof d.access_token === 'string' ? d.access_token : null;
  const device_id = typeof d.device_id === 'string' ? d.device_id : null;
  const user = d.user;
  if (!access_token || !device_id || !user || typeof user !== 'object') return null;
  return { access_token, user: user as Record<string, unknown>, device_id };
}

/** Trích `access_token` từ body JSON envelope `{ data: { access_token } }` hoặc tương thích camelCase. */
export function parseEnvelopeAccessToken(body: unknown): string | null {
  if (!body || typeof body !== 'object') return null;
  const o = body as Record<string, unknown>;
  const inner = o.data;
  if (inner && typeof inner === 'object') {
    const d = inner as Record<string, unknown>;
    if (typeof d.access_token === 'string') return d.access_token;
    if (typeof d.accessToken === 'string') return d.accessToken;
  }
  if (typeof o.access_token === 'string') return o.access_token;
  return null;
}
